import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import { ActionCommentRequestBody, ActionResponseBody, EntityType } from '@hm/core/models/action.interface';

import { environment } from '@hm/environments/environment';

import { InsurancePackage } from '@lib/core/models/insurance-package.interface';
import { MemberFranchiseItem, MemberProfile, MemberProfileSearch } from '@lib/core/models/member.interface';
import { PagedResponse } from '@lib/core/models/paged-response';
import { SearchRequest, searchRequestToUri } from '@lib/core/models/search-request';

@Injectable({
  providedIn: 'root',
})
export class MemberProfilesService {
  private http: HttpClient = inject(HttpClient);

  searchProfiles(search: SearchRequest<MemberProfileSearch>) {
    const searchString = searchRequestToUri(search);
    return this.http.get<PagedResponse<MemberProfile>>(`${environment.healthManagerApiUrl}/members?${searchString}`);
  }

  getClientProfile(id: string) {
    return this.http.get<MemberProfile>(`${environment.healthManagerApiUrl}/members/${id}`);
  }

  getClientProfileByUserId(userId: string): Observable<MemberProfile> {
    return this.http.get<MemberProfile>(`${environment.healthManagerApiUrl}/members/by-user/${userId}`);
  }

  getClientProfileComments(entityId: string): Observable<PagedResponse<ActionResponseBody>> {
    const requestBody = {
      pageSize: 100,
      sortBy: 'CreatedAt',
      sortDirection: 'desc',
      entityId,
      entityType: EntityType.Member,
    };
    return this.http.post<PagedResponse<ActionResponseBody>>(`${environment.healthManagerApiUrl}/actions/search`, requestBody);
  }

  createClientProfileComment(action: ActionCommentRequestBody): Observable<ActionResponseBody> {
    return this.http.post<ActionResponseBody>(`${environment.healthManagerApiUrl}/actions`, action);
  }

  updateClientProfileComment(actionId: string, actionContent: string): Observable<ActionResponseBody> {
    const requestBody = {
      content: actionContent,
    };
    return this.http.patch<ActionResponseBody>(`${environment.healthManagerApiUrl}/actions/${actionId}`, requestBody);
  }

  deleteClientProfileComment(actionId: string): Observable<void> {
    return this.http.delete<void>(`${environment.healthManagerApiUrl}/actions/${actionId}/archive`);
  }

  getPackageFranchisesByUserId(userId: string): Observable<MemberFranchiseItem[]> {
    return this.http.get<MemberFranchiseItem[]>(`${environment.healthManagerApiUrl}/members/by-user/${userId}/franchises`);
  }

  getPackageByUserId(userId: string): Observable<InsurancePackage> {
    return this.http.get<InsurancePackage>(`${environment.healthManagerApiUrl}/members/by-user/${userId}/package`);
  }

  getPackageFranchisesByMemberId(memberId: string): Observable<MemberFranchiseItem[]> {
    return this.http.get<MemberFranchiseItem[]>(`${environment.healthManagerApiUrl}/members/${memberId}/franchises`);
  }
}
